import g from "./globals";
import api from "./api";
import { desiredWidth, srcForResolution } from "./helpers";

// Wrap helper
export const wrap = (wrapper, elm) => {
  const opts = {
    totalWidth: 0,
    originalRects: [],
  };
  if (elm.length > 1) {
    elm[0].parentNode.insertBefore(wrapper, elm[0]);
    elm.forEach(el => {
      opts.originalRects.push(el.getBoundingClientRect());
      opts.totalWidth += (window.innerHeight * el.getBoundingClientRect().width) / el.getBoundingClientRect().height;
      wrapper.appendChild(el);
    });
  } else if (typeof elm === "object" && !elm.length) {
    elm.parentNode.insertBefore(wrapper, elm);
    opts.originalRects.push(elm.getBoundingClientRect());
    opts.totalWidth = (window.innerHeight * elm.getBoundingClientRect().width) / elm.getBoundingClientRect().height;
    wrapper.appendChild(elm);
  }
  return opts;
};

export const slideToggle = elm => {
  if (!elm.classList.contains("active")) {
    elm.classList.add("active");
    elm.classList.remove("inactive");
  } else {
    elm.classList.add("inactive");
    elm.classList.remove("active");
  }
};

// TODO: legacy
export const srcFor = (xmedia, options) => {
  if (options == null) {
    options = {
      qs: true,
    };
  }
  const width = desiredWidth(options);

  if (!/_\d+$/.test(xmedia.name)) {
    xmedia.name += "_1";
  }
  const pristine = xmedia.name.replace(/_1$/, "_0");
  let extension = "jpg";
  if (xmedia.type === "video" || xmedia.type === "hls") {
    extension = options.allowHls && xmedia.type === "hls" ? "m3u8" : "mp4";
    return `${g.baseImagesUrl.replace(/photos/, "video")}${xmedia.path}/${xmedia.name}.${extension}?ts=${xmedia.timestamp}`;
  }
  if (options.qs) {
    return `${g.baseImagesUrl}${xmedia.path}/${pristine}.${extension}?ts=${xmedia.timestamp}&imwidth=${width}`;
  }
  return `${g.baseImagesUrl}${xmedia.path}/w/${width}/${pristine}.${extension}?ts=${xmedia.timestamp}`;
};

// TODO: eliminar por el equipo de contenidos en una refactorizaición sobre enhancements
export const foldMenu = () => api.foldMenu();
export const unfoldMenu = () => api.unfoldMenu();
export const sanetizedSrcFor = path => srcForResolution(path);
